<template>
  <component :is="way" v-bind="{ ...$attrs, ...$props }" v-on="$listeners" />
</template>

<script>
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import Default from './default';
const Sibur = () =>
  import(/* webpackChunkName: 'sibur-test' */ '@/process/sibur-test/components/invites/creation/RowEditable');
const Citibank = () =>
  import(/* webpackChunkName: 'citibank' */ '@/process/citibank/components/invites/creation/ProcessRowEditable');

export default {
  name: 'RowEditableWrapper',

  components: {
    Default,
    Sibur,
    Citibank
  },

  computed: {
    // проверка на конкретную выбранную вакансию
    ...mapGetters('invites/creation', ['hasProcess']),

    // проверка включен ли спецпроцесс (например, для компании в целом)
    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.hasProcess(PROCESS_NAMES.SIBUR_TEST)) {
        return 'sibur';
      } else if (this.getProcessName !== undefined && this.getProcessName === PROCESS_NAMES.CITIBANK) {
        return this.getProcessName;
      }

      return 'default';
    }
  }
};
</script>
